import React from 'react';
import { withTranslation } from 'react-i18next';
import { ModalHeader, Button, ModalBody, Row, Col, FormGroup } from 'reactstrap';
import { modalWrapper } from 'components/FDModal';
import { CardImage } from 'components/Common';
import { formatCardWithSpace } from 'lib/fp-utility';

class DeleteCardModal extends React.Component {

    render() {
        const { t } = this.props;
        return (
            <>
                <ModalHeader toggle={this.props.closeModal}>{t('delete_card')}</ModalHeader>
                <ModalBody>
                    <div className="text-center mb-4">
                        <FormGroup className="notMinHgt">
                            <Row>
                                <Col className="group-dd m-0" md="12">
                                    <div className="cardType-dd">
                                    <CardImage cardType={this.props.selectedDeleteCard.name} />
                                    </div>
                                    <p className="numField">{formatCardWithSpace(this.props.selectedDeleteCard.alias)}</p>
                                </Col>
                            </Row>
                        </FormGroup>
                        <p className="text-16 mb-2">{t('delt_note1')}</p>
                    </div>
                    <div className="d-flex btn-135 pt-2" role="group">
                        <Button outline color="secondary" onClick={this.props.closeModal}>{t('No')}</Button>
                        <Button onClick={this.props.deleteSavedCard}>{t('Yes')}</Button>
                    </div>
                </ModalBody>
            </>
        )
    }
}

const savedCardDeleteModal =  withTranslation('translations')(modalWrapper(false, "DeleteCard")(DeleteCardModal));


// const mapStateToProps = state => {
//     if(state.fdData && state.fdData.savedCardDeleteResp){
//         const { savedCardDeleteResp: {vaultCardAvailable, status} } = state.fdData
//         if(vaultCardAvailable && status==='SUCCESS'){
//             return { deleteStatus: true, deleteStatusMsg: 'Deleted successfully'}
//         }else if(!vaultCardAvailable && status==='FAILED'){
//             return { deleteStatus: false, deleteStatusMsg: 'Something went wrong!'}
//         }
//     }
// }

// export default connect(null, {callDeleteSavedCard})(savedCardDeleteModal);
export default savedCardDeleteModal;